import axios from 'axios';
import { createApiUrl } from '../util';
import api from 'api/axiosInstance';

async function verifyToken(token: string) {
	const { data } = await api.get(createApiUrl(`/organization/verify/${token}`));
	return data;
}

export {
	verifyToken
};